import styled, { css } from 'styled-components'
import { FontWeightKey } from '../Types/Cura'

interface BoldProps {
  $weight?: FontWeightKey
}

export const Bold = styled.strong<BoldProps>`
  ${({ theme, $weight = 'medium' }) => css`
    font-weight: ${theme.fonts.getWeights()[$weight]};
  `}
`
